import { render } from "./ErdStall.vue?vue&type=template&id=0e1325ef&scoped=true"
import script from "./ErdStall.vue?vue&type=script&lang=js"
export * from "./ErdStall.vue?vue&type=script&lang=js"

import "./ErdStall.vue?vue&type=style&index=0&id=0e1325ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1325ef"]])

export default __exports__